<template>
    <teleport to="body">
        <div class="modal fade" tabindex="-1" ref="modal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5">Составление позиции</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3">
                            <div class="form-label">Название <span class="text-primary">*</span></div>
                            <input type="text" class="form-control" placeholder="Введите название..." v-model.trim="name" v-bind:disabled="id > 0" />
                        </div>

                        <div class="row row-cols-2 g-3 mb-3">
                            <div class="col">
                                <div class="form-label">Объем (мл) <span class="text-primary">*</span></div>
                                <input type="number" class="form-control" step="1" v-model.number="volume" />
                            </div>

                            <div class="col">
                                <div class="form-label">Цена (руб) <span class="text-primary">*</span></div>
                                <input type="number" class="form-control" step="0.01" v-model.number="price" />
                            </div>
                        </div>

                        <div class="mb-3" v-if="id === 0">
                            <div class="form-label">Категория</div>
                            <select class="form-select" v-model.number="categoryId">
                                <option
                                    v-for="[id, name] of Object.entries(categories)"
                                    v-bind:key="id"
                                    v-bind:value="id"
                                >{{name}}</option>
                            </select>
                        </div>

                        <div class="" v-if="id === 0 || description.length > 0">
                            <div class="d-flex justify-content-between">
                                <div class="d-flex form-label">
                                    <div class="me-2">Описание</div>
                                    <div class="bg-light rounded px-2" v-if="id !== 0">
                                        <div class="form-check mb-0">
                                            <input class="form-check-input" type="checkbox" id="hideDescriptionCheck" v-model="hideDescription" />
                                            <label class="form-check-label" for="hideDescriptionCheck">отключить</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-secondary">{{description.length}} / 250</div>
                            </div>

                            <textarea
                                v-bind:class="{
                                    'form-control': true,
                                    'opacity-50': hideDescription
                                }"
                                placeholder="Введите описание позиции..."
                                maxlength="250"
                                v-bind:disabled="id > 0"
                                v-model.trim="description"
                            ></textarea>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Отмена</button>
                        <button type="button" class="btn btn-primary" v-on:click="onSubmit" v-bind:disabled="name.length < 3"><i class="bi bi-check-circle"></i> Применить</button>
                    </div>
                </div>
            </div>
        </div>
    </teleport>
</template>

<script>
import {Modal} from 'bootstrap'

export default {
    name: "ComposeProductModal",
    data() {
        return {
            id: 0,
            name: '',
            description: '',
            hideDescription: false,
            volume: null,
            price: null,
            index: -1,
            categoryId: 0,

            bsModal: null
        }
    },
    props: {
        categories: {
            type: Object,
            default: () => {}
        }
    },
    methods: {
        show(product = {}, index = -1) {
            this.id = product.id || 0;
            this.name = product.name || '';
            this.description = product.description || '';
            this.hideDescription = false;
            this.volume = product.volume || 250.0;
            this.price = product.price || 100.0;
            this.categoryId = product.category_id || 1;
            this.index = index;
            this.bsModal.show();
        },
        hide() {
            this.bsModal.hide();
        },
        onSubmit() {
            this.$emit('submit', {
                name: this.name,
                description: this.hideDescription ? '' : this.description,
                volume: this.volume,
                price: this.price,
                category_id: this.categoryId,
                index: this.index
            });

            this.bsModal.hide();
        }
    },
    mounted() {
        this.bsModal = Modal.getOrCreateInstance(this.$refs.modal);
    },
    unmounted() {
        this.bsModal.dispose();
    }
}
</script>